import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import './styles.css';

function renderApplication() {
  const root = document.getElementById('root');
  if (!root) throw new Error('ModIQ frontend root element is missing');
  const basename = window.location.pathname === '/app-v2' || window.location.pathname.startsWith('/app-v2/')
    ? '/app-v2'
    : undefined;
  const routerProps = basename ? { basename } : {};

  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter {...routerProps}>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}

if (window.self !== window.top && window.top) {
  window.top.location.replace(window.location.href);
} else {
  renderApplication();
}
